
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { offsetOneRow, offsetTwoRows, StateStyledNumberCell } from "../../Styles/ParticipationTableStyles";
import { CellWithValidator, StickyNumericHeader } from "../../../../components/Table/TableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { NumericFilter } from "../../../../components/Form/FormStyles";

export function ProjectCommunityTreesPlantedHeader() {
	return (
		<StickyNumericHeader
			style={{
				...offsetOneRow,
				width: '120px',
				minWidth: '120px',
				maxWidth: '120px'
			}}>
			Community trees planted
		</StickyNumericHeader>
	)
}

export function ProjectCommunityTreesPlantedFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyNumericHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.ProjectCommunityTreesPlantedValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							ProjectCommunityTreesPlantedValidated: e.value
						})
					}
				/>
				<NumericFilter
					value={filter?.ProjectCommunityTreesPlanted ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							ProjectCommunityTreesPlanted: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyNumericHeader>
	)
}

export function ProjectCommunityTreesPlantedContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledNumberCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CommunityTreesPlantedValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.CommunityTreesPlanted?.toLocaleString()}</span>
			</CellWithValidator>
		</StateStyledNumberCell>
	)
}